import { createSlice } from "@reduxjs/toolkit"

//Slice o porcion de estado 
const initialStateUsuario = {
  idusuario: 0,
  nombreCompleto: "",
  autorizado: false,
  usuario:"",
  roles: [],
  isUserLetrado : false,
  isUserMedico : false,
  isUserTecnico : false,
  isUserJuicio:false,
  idLetrado: ""
}

export const userSlice = createSlice({ 
  name: "usuario", 
  initialState: initialStateUsuario, 
  reducers:{
    addUser: (state, action)=>{
      const {idusuario, nombreCompleto, autorizado, token, usuario, roles, idUsuarioAplicacion}=action.payload
      state.usuario=usuario
      state.roles=roles
      state.idusuario=idusuario
      state.nombreCompleto=nombreCompleto
      state.autorizado = autorizado
      state.idLetrado = idUsuarioAplicacion
      state.isUserLetrado = state.roles.some(role => role.idRol === 10)
      state.isUserMedico = state.roles.some(role => role.idRol === 11)
      state.isUserTecnico = state.roles.some(role => role.idRol === 12)
      state.isUserJuicio = state.roles.some(role => role.idRol === 13)
      sessionStorage.setItem("usuario", JSON.stringify(state))
      sessionStorage.setItem("AUTH_TOKEN", token)
    },
    changeId: (state, action)=>{
      state.idusuario=action.payload
    },
    changeNombreCompleto: (state, action)=>{
      state.nombreCompleto=action.payload
    },
    changeAutorizado: (state, action)=>{
      state.autorizado=action.payload
    },
    changeUsuario: (state, action)=>{
      state.usuario=action.payload
    }
  }
})

export const {addUser, changeId, changeNombreCompleto, changeUsuario,autorizado, roles} = userSlice.actions
export default userSlice.reducer
